import React from 'react';
import Hero from './components/rti/Hero';
import Main from './components/rti/Main';

const RTI = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default RTI;